import React from 'react'
import HistoryContainer from './HistoryContainer'
import HistoryView from './HistoryView'

const HistoryPage = () => {
	return <HistoryContainer>{HistoryView}</HistoryContainer>
}

export default HistoryPage
